import { ImageFocusLevelDTO } from 'business/models/Models';
import { MenuItem } from 'components/dropdowns/RMDropdown';

export const buildFocusLevelOptions = (
  focusLevelImages: ImageFocusLevelDTO[],
  currentImageId: number | undefined,
  onSelect: (image: ImageFocusLevelDTO) => void,
): MenuItem[] | null => {
  if (focusLevelImages.length <= 1) {
    return null;
  }
  return focusLevelImages.map((flImage) => ({
    label: flImage.imageTitle,
    onClick: () => onSelect(flImage),
    isSelected: flImage.imageId === currentImageId,
    shouldShowSelectedItemCheckmark: true,
  }));
};

export const experiment = {
  RotateExpName: '_Rot180',
} as const;
